import { RouteRecordRaw } from 'vue-router'

const Organizations = () =>
  import(/* webpackChunkName: "organizations-view" */ './pages/index.vue')

export const moduleRoutes: Array<RouteRecordRaw> = [
  {
    path: 'organizaciones',
    name: 'organizations',
    component: Organizations,
    meta: {
      title: 'Organizaciones',
      auth: {
        requiredPermission: 'organizations.view',
        requiredModule: 'organizations',
        redirect: '/auth/login',
        forbiddenRedirect: '/inicio',
      },
    },
  },
]
